import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncRouteEdit = lazy(() => import('~/containers/RouteEdit'));

export default [
  <Route path="/routes/:routeId">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncRouteEdit />
    </Suspense>
  </Route>,
];
